const USE_DUMMY_DATA = true;
import get from './get';
import post from './post';
import patch from './patch';
import put from './put';
import _delete from './delete';
import utilsService from '@/services/utils.service';


const mapAsOf = (body: any) => {
  if (body.asOf) {
    body.as_of = utilsService.convertAsOfToDate(body.asOf).toISOString().slice(0, 10);
    delete body.asOf;
  }
}

const nextRequestId = () => {
  localStorage.topRequestId = (parseInt(localStorage.topRequestId, 10) || 0) + 1;
  return localStorage.topRequestId;
}

export default {
  async getOptions(useAuth: boolean = true) {
    try {
      const res = await get(`/api/options`, useAuth);
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  async calculateResultsCancel(useAuth: boolean = true) {
    // cancel outstanding request before issuing new one
    const requestId = sessionStorage.getItem('calculateResultsRequestId');
    if (requestId) {
      sessionStorage.removeItem('calculateResultsRequestId');
      try {
        await _delete(`/api/requests/${requestId}`, true);
      } catch (err) {
        console.log("Error cancelling previous calculate result: ",err);
      }
    }
  },
    
  async calculateResults(profile: any, useAuth: boolean = true) {
    const reqId = sessionStorage.calculateResultsRequestId = nextRequestId();
 
    try {
      const body: any = { ...profile };
      body.request_id = reqId;
      delete body.time;
      delete body.bucketId;
      delete body.buckets;
      delete body.bucket;
      delete body.id;
      delete body.name;
      if (body.type) {
        body.types = [body.type];
        delete body.type;
      }
      mapAsOf(body);
      const res = await post(`/api/calculate_result`, body, useAuth);
      if (reqId == sessionStorage.calculateResultsRequestId) {
        return {
          res,
          profile
        };
      } else {
      	// this request ID differed from latest request ID so this request must have been cancelled
	      // so return nothing
      }
    } catch (err) {
      if (reqId === sessionStorage.getItem('calculateResultsRequestId')) {
        throw err;
      }
    } finally {
      if (reqId === sessionStorage.getItem('calculateResultsRequestId')) {
        sessionStorage.removeItem('calculateResultsRequestId');
      }
    }
  },
  async getAttrValues(basicProfile: any, useAuth: boolean = true) {
    try {
      const body: any = { ...basicProfile };
      delete body.time;
      delete body.bucketId;
      delete body.bucket;
      delete body.buckets;
      delete body.id;
      delete body.name;
      if (body.type) {
        body.types = [body.type];
        delete body.type;
      }
      mapAsOf(body)
      console.log('Payload for /api/distinct_attribute_values:', JSON.stringify(body, null, 2));
      const res = await post(`/api/distinct_attribute_values`, body, useAuth);
      return res;
    } catch (err) {
      throw err;
    }
  },
  async downloadResults(profile: any, useAuth: boolean = true) {
    const body = { ...profile };
    delete body.bucketId;
    delete body.bucket;
    delete body.buckets;
    delete body.time;
    delete body.id;
    delete body.name;
    mapAsOf(body)
    try {
      const res = await post(`/api/download`, body, useAuth, null, 'arraybuffer');
      return res;
    } catch (err) {
      throw err;
    }
  },
  async getProfiles() {
    try {
      const res = await get(`/api/profiles`);
      // NOTE: I am going to leave this commented for now (rather than deleting), as it
      // helps testing of profiles with old dates.

      // res.data.data = res.data.data.map((obj: any) => {
      //   obj.data.asOf = {
      //     data: "2019-02-10",
      //     type: "static"
      //   }
      //   return obj;
      // })
      return res;
    } catch (err) {
      throw err;
    }
  },
  async saveProfile(profile: any) {
    if (!profile.id) {
      delete profile.id;
    }
    try {
      const res = await post(`/api/profiles`, profile, true);
      return res;
    } catch (err) {
      throw err;
    }
  },
  async replaceProfile(id: string, profile: any) {
    try {
      const res = await put(`/api/profiles/${id}`, profile, true);
      return res;
    } catch (err) {
      throw err;
    }
  },
  async deleteProfile(id: string, profile: any) {
    try {
      const res = await _delete(`/api/profiles/${id}`, true);
      return res;
    } catch (err) {
      throw err;
    }
  },
  async sendFeedback(score: number, comment?: string, useAuth: boolean = true) {
    try {
      const res = await post(`/feedback`, { score, comment }, true);
      return true;
    } catch (err) {
      throw err;
    }
  },
  async getCustomBuckets() {
    return new Promise ((resolve) => {
      try {
        const local: string = localStorage.getItem('buckets') || '';
        if (local) {
          resolve(JSON.parse(local));
        } else {
          resolve([]);
        }
      } catch (err) {
        throw err;
      }
    });
  },
  async saveCustomBucket(bucket: any) {
    try {
      const local: string = localStorage.getItem('buckets') || '[]';
      const existing: any[] = JSON.parse(local);
      existing.push(bucket);
      localStorage.setItem('buckets', JSON.stringify(existing));
      return {
        success: true,
        buckets: existing
      };
    } catch (e) {
      throw e;
    }
  },
  async deleteCustomBucket(bucketId: string) {
    try {
      const local: string = localStorage.getItem('buckets') || '[]';
      const existing: any[] = JSON.parse(local);
      const index = existing.findIndex((bucket: any) => bucket.id === bucketId);
      existing.splice(index, 1);
      localStorage.setItem('buckets', JSON.stringify(existing));
      return {
        success: true,
        buckets: existing
      };
    } catch (e) {
      throw e;
    }
  },

};
